export default "__VITE_ASSET__D3f0lnmw__"